module.exports = __webpack_public_path__ + "static/img/pinp@2x.74eec79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pinp@2x.png
// module id = Tgcq
// module chunks = 1